<template>
  <div
    class="row-1 editorial-double-columns-images"
    :class="{
      '--double-on-small': content.doubleColumn.includes('si'),
    }"
    v-anim-parallax-element="{
      target: 'picture',
      offset: 10,
    }"
  >
    <div
      class="editorial-double-columns-images__column"
      v-for="(image, index) in props.content.images"
      :key="image.id"
      v-anim-scroll-speed="{
        factor: index % 2 !== 0 ? 0.25 : 0,
      }"
    >
      <WidgetPicture
        :image="{
          custom: image,
        }"
        :lazyLoad="true"
        :alt="image.title"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorialGalleryImages',
}
</script>

<script setup>
const props = defineProps({
  content: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
